import { render, staticRenderFns } from "./editorV2artical.vue?vue&type=template&id=11f79161"
import script from "./editorV2artical.vue?vue&type=script&lang=js"
export * from "./editorV2artical.vue?vue&type=script&lang=js"
import style0 from "./editorV2artical.vue?vue&type=style&index=0&id=11f79161&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports